import createValueModule from "@redux/create-value-module";

import { $LocalesModuleName, TLocalesState } from "./locales.types";

const { constants: _constants, actions } = createValueModule<TLocalesState>(
    $LocalesModuleName,
    {
        current: undefined,
        locales: [],
    },
);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
